import { render, staticRenderFns } from "./monitoring.vue?vue&type=template&id=3b9b281c"
import script from "./monitoring.vue?vue&type=script&lang=js"
export * from "./monitoring.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports